import * as ThemeManager from './ThemeManager';

export function PhoneOnly({ children }: React.PropsWithChildren) {
	return ThemeManager.isPhone() ? children : null;
}